import { useContext, useEffect, useState } from 'react';
import {
  Registration,
  RegistrationApplicationStatusLog
} from '@stax-core/types-omni';
import { RegistrationStore } from '../context';
import { forEach, isEmpty } from '../util/object.util';

type ReviewStep = keyof RegistrationApplicationStatusLog;

const precedenceMap: Record<ReviewStep, number> = {
  signApplication: 0,
  internalReview: 1,
  externalReview: 2,
  approval: 3
};

export function useReviewProgress(): {
  reviewStep: ReviewStep;
  reviewStepIndex: number;
} {
  const [reviewStep, setReviewStep] = useState<ReviewStep>('signApplication');
  const {
    state: { effect }
  } = useContext(RegistrationStore);

  useEffect(() => {
    if (effect && effect.type === 'UPDATE_REGISTRATION') {
      const registration: Registration = effect.payload?.registration;

      if (isEmpty(registration) || isEmpty(registration.meta)) return;

      let reviewStep: ReviewStep = 'signApplication';

      const { applicationStatusLog = {} } = registration.meta;

      forEach(applicationStatusLog, (step: ReviewStep, value) => {
        const isActive =
          value &&
          value.status &&
          ['inprogress', 'success'].includes(value.status);

        if (isActive && precedenceMap[step] > precedenceMap[reviewStep]) {
          reviewStep = step;
        }
      });

      setReviewStep(reviewStep);
    }
  }, [effect]);

  return { reviewStep, reviewStepIndex: precedenceMap[reviewStep] };
}
